// convienience type for taylor series expansions
// see https://www.gdcvault.com/play/10103/Dual-Numbers-Simple-Math-Easy
// for details on deriv numbers

/**
 * Partial implementation of Dual number class
 */
export class Dual {
  real = 0;
  deriv = 0;

  constructor(r?: number, d?: number) {
    if (r) {
      this.real = r;
    }
    if (d) {
      this.deriv = d;
    }
  }

  copy(other: Dual) {
    this.real = other.real;
    this.deriv = other.deriv;

    return this;
  }

  set(r: number, d: number) {
    this.real = r;
    this.deriv = d;
  }

  add(other: Dual) {
    this.real += other.real;
    this.deriv += other.deriv;

    return this;
  }

  mul(other: Dual) {
    const lhs = this.real * other.real;

    this.deriv = this.real * other.deriv + this.deriv * other.real;
    this.real = lhs;

    return this;
  }

  square() {
    const lhs = this.real ** 2;

    this.deriv = 2 * (this.real * this.deriv);
    this.real = lhs;

    return this;
  }

  addScalar(scalar: number) {
    this.real += scalar;

    return this;
  }

  recipDivScalar(scalar: number) {
    const lhs = scalar / this.real;

    this.deriv = (-lhs * this.deriv) / this.real;
    this.real = lhs;

    return this;
  }
}
